import React, {Component}          from 'react';
import PubSub                      from 'pubsub-js';
import { withRouter }              from 'react-router';
import { connect as reduxConnect } from 'react-redux';
import { isLoggedIn }              from '../../../utils/authService';
import { connectTokenFetchData }   from '../../../actions/connect/token';
import { ConnectConstants }        from '../connect/environment';

var apiHost = ConnectConstants.WebApiHost;

export class SendFeedback extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      userId: ''
    };
    
    this.triggerNext = this.triggerNext.bind(this);
    this.subscriber  = this.subscriber.bind(this);
  }
  
  componentWillUnmount() {
    this.unsubscribe();
  }

  componentDidMount() {
    this.tokenA = PubSub.subscribe('feedback.response',       this.subscriber.bind(this));
    this.tokenB = PubSub.subscribe('feedback.response.error', this.subscriber.bind(this));
    this.tokenC = PubSub.subscribe('register.response',       this.subscriber.bind(this));
    this.tokenD = PubSub.subscribe('register.response.error', this.subscriber.bind(this));
    
    const { steps }  = this.props;
    if(steps.userFeedback && steps.userFeedback.value && steps.userFeedback.value.length > 0) {
      var value = steps.userFeedback.value;
      steps.userFeedback.value = '';
            
      if (/* TODO: Maybe implement in the future */false && isLoggedIn() && 'register' === value) {
        this.props.register(value); 
      }
      else {
        if (isLoggedIn()) {
          this.props.feedback(value);
        }
        else {
          if (!this.props.token) {
            this.unsubscribe();
            this.props.fetchDataToken(apiHost, this.props.userId);
            this.props.triggerNextStep({ trigger: 'token' });
          }
          else {
            this.props.feedback(value, steps.token.value);
          }
        }
      }
    }
  }

  subscriber(msg, data) {
    if (msg === "feedback.response") {
      this.triggerNext();
    }
    else if (msg === "feedback.response.error") {
      this.props.triggerNextStep({ trigger: 'error' });
    }
    else if (msg === "register.response") {
      this.props.triggerNextStep({ trigger: 'register-finish' });
    }
    else if (msg === "register.response.error") {
      this.props.triggerNextStep({ trigger: 'error' });
    }
  }

  triggerNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }
  
  unsubscribe() {
    PubSub.unsubscribe(this.tokenA);
    PubSub.unsubscribe(this.tokenB);
    PubSub.unsubscribe(this.tokenC);
    PubSub.unsubscribe(this.tokenD);
  }
    
  render() {
    return (
      <div>
      { isLoggedIn() ?
        <span>Processing your request...</span>
        :
        <span>Please enter the one-time token to proceed.</span>
      }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    connectToken: state.connect.connectToken.connectToken,
    tokenHasErrored: state.connect.connectToken.connectTokenHasErrored,
    tokenIsLoading: state.connect.connectToken.connectTokenIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataToken: (host, userId) => dispatch(connectTokenFetchData(host, userId))
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(SendFeedback));